module.exports = __webpack_public_path__ + "static/media/innovation.fb53521e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/innovation.jpg
// module id = 800
// module chunks = 5